import { NAPAY_PSP_ID } from 'Components/widgets/payment-info/PaymentInfo.const';
import { t } from 'Src/i18n';
import {
  isCheque,
  isPayPal,
  isTransfer,
} from 'Components/widgets/payment-info/payment-form/paymentProvidersUtils';
export const getB2BPaymentProviderLabel = ({
  paymentProvider,
  isTotalAmount,
  getLabelByCanal,
}: {
  paymentProvider: PaymentProvider;
  isTotalAmount: boolean;
  getLabelByCanal: (arg0: { cxoLabel: string; cmtaLabel: string }) => string;
}) => {
  const amountLabelKey = isTotalAmount ? 'totalAmount' : 'deposit';

  if (isTransfer(paymentProvider)) {
    return getLabelByCanal({
      cxoLabel: t(`booking.sellers.banking.paymentProvider.bankTransfer.${amountLabelKey}`),
      cmtaLabel: t(`booking.partners.banking.paymentProvider.bankTransfer.${amountLabelKey}`),
    });
  }

  if (paymentProvider.selectorId === NAPAY_PSP_ID) {
    return t(`booking.partners.paymentNA.${amountLabelKey}`);
  }

  if (isPayPal(paymentProvider)) {
    return t(`booking.sellers.banking.paymentProvider.paypal.${amountLabelKey}`);
  }

  if (isCheque(paymentProvider)) {
    return t(`booking.banking.paymentProvider.cheque.${amountLabelKey}`);
  }

  if (paymentProvider.shouldSkipPayment) {
    return t(
      `booking.banking.paymentSchedule.${isTotalAmount ? 'payFullAmount' : 'depositSelected'}`,
    );
  }

  return getLabelByCanal({
    cxoLabel: t(`booking.sellers.banking.paymentProvider.creditCard.${amountLabelKey}`),
    cmtaLabel: t(`booking.partners.banking.paymentProvider.creditCard.${amountLabelKey}`),
  });
};
